/** Mensaje inicial genérico: no contiene datos personales ni de una reserva. */
const MENSAJE_WHATSAPP_CONSULTAS = 'Hola, quiero hacer una consulta a M&M Pádel.';

/** Construye el enlace público sin pasar datos del visitante al sistema. */
function enlaceWhatsappConsultas(numeroInternacional: string): string {
  return `https://wa.me/${numeroInternacional}?text=${encodeURIComponent(
    MENSAJE_WHATSAPP_CONSULTAS,
  )}`;
}

export function BotonWhatsappConsultas({
  numeroInternacional,
}: {
  readonly numeroInternacional: string;
}): React.JSX.Element {
  return (
    <a
      aria-label="Consultar por WhatsApp (abre una pestaña nueva)"
      className="whatsapp-consultas"
      href={enlaceWhatsappConsultas(numeroInternacional)}
      rel="noopener noreferrer"
      target="_blank"
    >
      <span
        aria-hidden="true"
        className="whatsapp-consultas__icono"
      />
    </a>
  );
}
